
import { defineComponent, computed, ref, watch } from 'vue';
import IconComponent from './IconComponent.vue';
import TooltipComponent from '@/components/ui/TooltipComponent.vue';
import Stepper from '@/components/ui/StepperComponent.vue';
export default defineComponent({
    components: {
        IconComponent,
        TooltipComponent,
        Stepper,
    },
    props: {
        label: {
            type: String,
            default: '',
        },
        state: {
            type: String,
            default: 'default',
        },
        type: {
            type: String,
            default: 'text',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        disabledUp: {
            type: Boolean,
            default: false,
        },
        disabledDown: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        closeIcon: {
            type: Boolean,
            default: false,
        },
        stepper: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: [String, Number],
            default: '',
        },
        counter: {
            type: Boolean,
            default: false,
        },
        maxlength: {
            type: Number,
            default: undefined,
        },
        textarea: {
            type: Boolean,
            default: false,
        },
        inputModalTag: {
            type: Boolean,
            default: false,
        },
        heightTextarea: {
            type: Number,
            default: 76,
        },
        countItem: {
            type: Number,
            default: 0,
        },
    },
    emits: ['update:modelValue','clear'],
    setup(props, { emit }) {
        const valueSync = computed({
            get(): any {
                return props.modelValue;
            },
            set(value: any) {
                emit('update:modelValue', value);
            },
        });

        const textfieldComp = ref<any>(null);

        const states = ['error', 'default'];

        const classInputContainer = computed(() => {
            const state = {
                'ring-error border-error-3': props.state === 'error',
                'bg-white': !props.disabled,
                'bg-neutrals-50 cursor-not-allowed pointer-events-none': props.disabled,
                'ring-primary border-neutrals-200 focus-within:border-primary-500 hover:border-primary-500 hover:ring-4  hover:ring-primary-50':
                    (props.state === 'default' || !states.includes(props.state)) && !props.disabled,
            };

            return { ...state };
        });

        const isShowPassword = ref(false);

        const passwordType = computed(() => {
            return isShowPassword.value ? 'text' : 'password';
        });

        const classInput = computed(() => {
            const state = {
                ' placeholder-neutrals-500 text-neutrals-900': !props.disabled,
                ' placeholder-neutrals-300 text-neutrals-300': props.disabled,
            };
            return {
                ...state,
            };
        });

        const onPressed = (type: string) => {
            let temp: number = parseInt(valueSync.value);
            if (!temp) temp = 0;
            temp = type === 'down' ? temp - 1 : temp + 1;
            emit('update:modelValue', temp);
            valueSync.value = temp.toString();
        };

        const onClearText = () => {
            emit('clear')
            emit('update:modelValue', '');
            valueSync.value = '';
            const ref: any = textfieldComp.value;
            ref.focus();
        };

        const onSelectAll = () => {
            textfieldComp.value?.focus();
            textfieldComp.value?.select();
        };

        return {
            classInput,
            classInputContainer,
            states,
            onClearText,
            textfieldComp,
            onPressed,
            isShowPassword,
            passwordType,
            valueSync,
            onSelectAll,
        };
    },
});
